<template>	
	<div class="container 2fa" style="text-align: center;">
    <template v-if="step == 1">
      <template v-if="qr">
        <div class="row mt-5">
          <div class="col-md-6 mt-5">
            <div class="">
              <!-- <img :src="'https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl='+this.qr+'&chld=L|1&choe=UTF-8'"> -->
              <img :src="'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data='+this.qr">
            </div>
          </div>

          <div class="col-md-6 mt-5">

            <h1 class="">Escanea este codigo de barras con Authy o Google Authenticator</h1>
            <p style="font-size: 18px;">
              Con el fin de brindarle mayor seguridad en nuestra plataforma; lo invitamos a que descargue desde la play store o app store el segundo método de seguridad llamado token; las aplicaciones recomendadas son Authy o Google Authenticator, este método consiste en generar un código dinámico el cual le brindara seguridad en cada acceso.
            </p>
            <button type="button" class="mt-3 btn btn-space btn-primary btn-lg" v-on:click="next()">Continuar</button>
          </div>
        </div>
      </template>
      <template v-else>
        <h1>Te estamos generando un Token, por favor espere...</h1>
        <app-loader/>
      </template>
    </template>
    <template v-else-if="step == 2">
      <div class="token">
        <form v-on:submit.prevent="verify">
          <div class="report-box mb-5">
            <h1  class="mt-5 mb-5">Código</h1>
            <div class="form-group">
              <input type="text" class="form-control input-token box-input" v-model="form.token">
            </div>
            <button type="submit"  class="mt-3 btn btn-space btn-primary btn-lg">Verificar</button>
          </div>
        </form>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GENERATE_2FA_TOKEN, VERIFY_2FA_TOKEN } from "@/store/actions.type";
import AppLoader from "@/components/AppLoader.vue";
export default {
  components: {
    AppLoader
  },
  data() {
    return {
      qr: "",
      step: 1,
      form: {
        token: ""
      }
    };
  },
  mounted() {
    this.fetchToken();
  },
  computed: {
    ...mapGetters(["brand"])
  },
  methods: {
    fetchToken() {
      this.$store.dispatch(GENERATE_2FA_TOKEN).then(token => {
        this.qr = token.otpauth_url;
      });
    },
    next() {
      this.step++;
    },
    verify() {
      this.$store
        .dispatch(VERIFY_2FA_TOKEN, this.form)
        .then(result => {
          window.localStorage.removeItem("need2fa");
          this.$router.push({ name: "home" });
          this.$snotify.success(result.message);
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    }
  }
};
</script>

<style lang="scss">
.input-token {
  font-size: 40px;
  padding: 25px;
  width: 185px;
  margin: 0 auto;
}
.token {
  margin: 200px auto;
  width: 50%;
  text-align: center;
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
</style>
